import { Button } from '@eliadmin/core/src/components/ui/button';
import { MdArticle, MdOutlineFileDownload } from 'react-icons/md';
import { RiDeleteBin6Fill } from 'react-icons/ri';

type StartFormFileProps = {
  filename?: string;
  className?: {
    wrapper?: string;
    icon?: string;
    text?: string;
  };
};

export const StartFormFile = ({ filename, className }: StartFormFileProps) => {
  return (
    <div className="flex w-full items-center justify-between text-primary">
      <div className="flex items-center gap-3">
        <MdArticle className="h-6 w-6" />
        <h1 className="text-sm font-bold text-black">{filename}</h1>
      </div>
      <div className="flex gap-3">
        <Button variant="secondary" className="w-12 rounded-full p-0">
          <MdOutlineFileDownload className="h-5 w-5" />
        </Button>
        <Button variant="secondary" className="w-12 rounded-full p-0">
          <RiDeleteBin6Fill className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};
